import Router from 'next/router'
import { storedMfaEmail } from 'lib/helpers/mfaEmailStorage/mfaEmailStorage'
import { storedMfaAvailableMethods } from 'lib/helpers/mfaAvailableMethodsStorage/mfaAvailableMethodsStorage'
import { RouterPage } from 'lib/navigation/consts'
import type { MfaMethod } from 'gql/types'

interface WriteMfaStorageParams {
  email: string
  availableMethods: Maybe<MfaMethod[]>
}

/**
 * `email` is always set. `availableMethods` is set-or-cleared, so a method-less response can't inherit
 * a prior sign-in's methods.
 */
export const writeMfaStorage = ({ email, availableMethods }: WriteMfaStorageParams): void => {
  storedMfaEmail.set(email)

  if (availableMethods) {
    storedMfaAvailableMethods.set(availableMethods)
  } else {
    storedMfaAvailableMethods.clear()
  }
}

interface RouteParams {
  next?: Maybe<string>
}

export const routeToLoginSetup = ({ next }: RouteParams): void => {
  void Router.push({ pathname: RouterPage.loginSetup, query: { ...(next && { next }) } }, RouterPage.loginSetup)
}

export const routeToLoginVerify = ({ next }: RouteParams): void => {
  void Router.push({ pathname: RouterPage.loginVerify, query: next ? { next } : undefined })
}
